import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility';

const initialState = {
	data: [],
	loading: false,
};

const getFlowSettingsStart = (state) => {
	return updateObject(state, { loading: true });
};

const getFlowSettingsSuccess = (state, action) => {
	return updateObject(state, {
		data: action.data,
		loading: false,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_FLOW_SETTINGS_START:
			return getFlowSettingsStart(state);
		case actionTypes.GET_FLOW_SETTINGS_SUCCESS:
			return getFlowSettingsSuccess(state, action);

		default:
			return state;
	}
};

export default reducer;
